import React from 'react';
import unpick from '../../../utilities/unpick';
import bubbleUpEvents from '../../utilities/bubble-up-events';
import reformatValue from '../../utilities/reformat-value';
import InputMaskWrap from './input-mask-wrapper';
import HiddenComponents from './hidden-components';

export default function SimpleText(props) {
  const { isValid, hiddenField, onChange, mask, replacePattern } = props;
  const p = unpick(props, ['ariaLabel', 'isValid', 'hiddenField', 'replacePattern']);
  const eventProps = replacePattern
    ? {
        onChange(e) {
          bubbleUpEvents(e, [reformatValue(e, replacePattern.regExpString, replacePattern.newSubStr), onChange]);
        },
      }
    : '';

  const InputField = (
    <input
      type="text"
      {...p}
      {...eventProps}
      aria-label={props.ariaLabel || 'Text input'}
      aria-placeholder={props.placeholder || ''}
      aria-invalid={!isValid}
    />
  );

  let hiddenComponents = null;

  if (!hiddenField && props.autoComplete === 'cc-name') {
    hiddenComponents = {
      CreditCardNumber: {
        autoComplete: 'cc-number',
      },
      CardSecurityCode: {
        autoComplete: 'cc-csc',
      },
      CardExpirationDate: {
        autoComplete: 'cc-exp',
      },
    };
  }

  return (
    <>
      {mask ? <InputMaskWrap>{InputField}</InputMaskWrap> : InputField}
      {!hiddenField && props.autoComplete === 'cc-name' ? <HiddenComponents hiddenComponents={hiddenComponents} /> : ''}
    </>
  );
}

SimpleText.displayName = 'CardHolderName';

SimpleText.propTypes = {};
